function testimonialsl() {
     $('.testimonials-slider').slick({
       dots: true,
       slidesToShow: 1,
       slidesToScroll: 1,
       autoplay: true,
       autoplaySpeed: 3500,
       fade: true,
       cssEase: 'linear',
       arrows: false,
       infinite: true,
     });

}

$(document).ready(function(){
  if($(".flash-messages").length){
    $(".flash-messages").fadeIn();
    setTimeout(function(){
      $(".flash-messages").fadeOut();
    }, 2750);
  }
  $('#submitForm').click(function(){
     history.pushState({ home: "contact" }, "contact", "/#contact")
  });
  if ($(".testimonials-slider").length){
      testimonialsl();
  }
});
